var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationArea(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/location"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.6195 8.45C19.5695 3.83 15.5395 1.75 11.9995 1.75C11.9995 1.75 11.9995 1.75 11.9895 1.75C8.45955 1.75 4.41955 3.82 3.36955 8.44C2.19955 13.6 5.35955 17.97 8.21955 20.72C9.27955 21.74 10.6395 22.25 11.9995 22.25C13.3595 22.25 14.7195 21.74 15.7695 20.72C18.6295 17.97 21.7895 13.61 20.6195 8.45ZM11.9995 13.46C10.2595 13.46 8.84955 12.05 8.84955 10.31C8.84955 8.57 10.2595 7.16 11.9995 7.16C13.7395 7.16 15.1495 8.57 15.1495 10.31C15.1495 12.05 13.7395 13.46 11.9995 13.46Z",
    fill: "#DB4D29"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationArea);
export default __webpack_public_path__ + "static/media/location-area.f5b22a2c02e540d2b88007b99c5fa29e.svg";
export { ForwardRef as ReactComponent };